import { tss } from "tss-react/mui"
import { alpha } from "@mui/material/styles"
import { IconButton } from "@mui/material"
import { faHeart, faStar } from "@fortawesome/pro-solid-svg-icons"
import { faHeart as faHeartBorder, faStar as faStarBorder } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Placement = "top-left" | "top-right" | "inline"

type Variant = "heart" | "star"

type StyleProps = Readonly<{ placement: Placement; variant: Variant; isFavorite: boolean }>

const useStyles = tss.withParams<StyleProps>().create(({ theme, placement, variant, isFavorite }) => ({
    button: {
        position: placement === "inline" ? "static" : "absolute",
        top: placement === "inline" ? undefined : ".75rem",
        left: placement === "top-left" ? ".75rem" : undefined,
        right: placement === "top-right" ? ".75rem" : undefined,
        padding: ".375rem",
        background: placement === "inline" ? undefined : alpha(theme.palette.common.white, 0.5),
        color: variant === "star" && !isFavorite ? theme.palette.tailwind.slate[300] : theme.palette.tailwind.blue[600],
        zIndex: 2,
        transition: "all 0.3s ease-out",
        "&:hover": {
            background: placement === "inline" ? theme.palette.tailwind.slate[100] : theme.palette.common.white,
            color: theme.palette.tailwind.blue[800],
        },
    },
}))

const ICONS = {
    heart: { on: faHeart, off: faHeartBorder },
    star: { on: faStar, off: faStarBorder },
}

type FavoriteButtonProps = Readonly<{
    isFavorite: boolean
    placement?: Placement
    variant?: Variant
    title?: string
    onClick: () => void
}>

export function FavoriteButton({
    isFavorite,
    placement = "top-right",
    variant = "heart",
    title,
    onClick,
}: FavoriteButtonProps) {
    const { classes } = useStyles({ placement, variant, isFavorite })
    const icons = ICONS[variant]

    return (
        <IconButton className={classes.button} size="small" onClick={onClick} title={title} aria-label={title}>
            <FontAwesomeIcon icon={isFavorite ? icons.on : icons.off} />
        </IconButton>
    )
}
